import React from 'react';

const MessageModal = ({ 
  message, 
  title = 'Message', 
  type = 'info', // 'info', 'success', 'warning', 'error'
  onClose,
  showCloseButton = true,
  closeOnBackdrop = false
}) => {
  if (!message) return null;

  // Determine icon and colors based on type
  const getIconAndColors = () => {
    switch (type) {
      case 'success':
        return {
          iconBg: 'bg-green-100',
          iconColor: 'text-green-600',
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          )
        };
      case 'warning':
        return {
          iconBg: 'bg-orange-100',
          iconColor: 'text-orange-600',
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          )
        };
      case 'error':
        return {
          iconBg: 'bg-red-100',
          iconColor: 'text-red-600',
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
          )
        };
      default: // info
        return {
          iconBg: 'bg-blue-100',
          iconColor: 'text-blue-600',
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          )
        };
    }
  };

  const { iconBg, iconColor, icon } = getIconAndColors();

  const handleBackdropClick = (e) => {
    if (!closeOnBackdrop) return;
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000] p-4" 
      style={{ zIndex: 10000 }}
      onClick={handleBackdropClick}
    >
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-slideUp"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4">
          <div className={`mx-auto flex items-center justify-center h-16 w-16 rounded-full ${iconBg} mb-4`}>
            <svg className={`h-8 w-8 ${iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {icon}
            </svg>
          </div>
          <h2 className="text-xl font-bold text-gray-900 text-center mb-2">{title}</h2>
          <p className="text-gray-600 text-center whitespace-pre-line">{message}</p>
        </div>
        {showCloseButton && onClose && (
          <div className="flex justify-center">
            <button
              onClick={onClose}
              className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
                type === 'error' 
                  ? 'bg-red-600 text-white hover:bg-red-700' 
                  : type === 'warning'
                  ? 'bg-orange-600 text-white hover:bg-orange-700'
                  : type === 'success'
                  ? 'bg-green-600 text-white hover:bg-green-700'
                  : 'bg-blue-600 text-white hover:bg-blue-700'
              }`}
            >
              OK
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageModal;


